import moment from "moment-timezone";
import { Formats } from "..";
// Weekdays
export function getWeekdayIndex(day) {
    switch (day.toLowerCase()) {
        case "monday":
            return 1;
        case "tuesday":
            return 2;
        case "wednesday":
            return 3;
        case "thursday":
            return 4;
        case "friday":
            return 5;
        case "saturday":
            return 6;
        case "sunday":
            return 7;
        default:
            throw new Error("ERROR WEEKDAY");
    }
}
export function getWeekdayNext(day) {
    switch (day) {
        case "Sunday":
            return "Monday";
        case "Monday":
            return "Tuesday";
        case "Tuesday":
            return "Wednesday";
        case "Wednesday":
            return "Thursday";
        case "Thursday":
            return "Friday";
        case "Friday":
            return "Saturday";
        case "Saturday":
            return "Sunday";
        default:
            return "Monday";
    }
}
export function getWeekdayPrevious(day) {
    switch (day) {
        case "Sunday":
            return "Saturday";
        case "Monday":
            return "Sunday";
        case "Tuesday":
            return "Monday";
        case "Wednesday":
            return "Tuesday";
        case "Thursday":
            return "Wednesday";
        case "Friday":
            return "Thursday";
        case "Saturday":
            return "Friday";
        default:
            return "Monday";
    }
}
export function getWeekdayFromMomentISOIndex(day) {
    switch (day) {
        case 1:
            return "Monday";
        case 2:
            return "Tuesday";
        case 3:
            return "Wednesday";
        case 4:
            return "Thursday";
        case 5:
            return "Friday";
        case 6:
            return "Saturday";
        case 7:
            return "Sunday";
        default:
            throw new Error("ERROR WEEKDAY");
    }
}
// Millis
export function getMillisFromMinutes(minutes) {
    return 1000 * 60 * minutes;
}
export const millisFromSeconds = (second) => second * 1000;
export const millisFromMinutes = (min) => min * millisFromSeconds(60);
export const millisFromHours = (hours) => hours * millisFromMinutes(60);
export const millisFromDays = (days) => days * millisFromHours(24);
export const millisFrom = {
    seconds: millisFromSeconds,
    minutes: millisFromMinutes,
    hours: millisFromHours,
    days: millisFromDays,
};
// Dates
export function getPreviousDate(date) {
    return moment(date, Formats.moment.date).subtract(1, "day").format(Formats.moment.date);
}
export function getNextDate(date) {
    return moment(date, Formats.moment.date).add(1, "day").format(Formats.moment.date);
}
// Opening hours
export function openingHoursSort(hours) {
    hours = [...hours].sort((a, b) => {
        const aIndex = getWeekdayIndex(a.day);
        const bIndex = getWeekdayIndex(b.day);
        if (aIndex === bIndex) {
            const aMom = moment(a.open, "HH:mm");
            const bMom = moment(b.open, "HH:mm");
            if (aMom.isBefore(bMom))
                return -1;
            if (aMom.isAfter(bMom))
                return 1;
            return 0;
        }
        else {
            return aIndex - bIndex;
        }
    });
    return hours;
}
//# sourceMappingURL=index.js.map